import { useQueuedSelection } from '@reach/web-ui/hooks';
import { useToast } from '../../../../hooks/useToast';
import { useSetTemplateCategories } from '../queries';

/** Saves the template row's latest category selection after any in-flight save. */
export function useTemplateCategoryAssignment(args: { templateId: string; savedCategoryIds: string[] }) {
  const { templateId, savedCategoryIds } = args;
  const { addToast } = useToast();
  const setTemplateCategories = useSetTemplateCategories(templateId);
  const { selection, setSelection } = useQueuedSelection({
    savedIds: savedCategoryIds,
    save: categoryIds => setTemplateCategories.mutateAsync({ templateId, categoryIds }),
    onError: error =>
      addToast({
        title: 'Could not update categories',
        description: error.message,
        variant: 'destructive',
      }),
  });

  return { categoryIds: selection, assign: setSelection };
}
